import Reveal from "@/components/Reveal";
import Cta from "@/components/Cta";

// Reusable large final call-to-action band.
const FinalCTA = () => {
  return (
    <section className="bg-[#F5F6FB]" data-testid="final-cta">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
            Let's work together
          </p>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
            Ready to take the numbers off your plate?
          </h2>
          <p className="mt-6 text-lg text-[#51607A] leading-relaxed">
            Get a clear, fixed monthly quote tailored to your business. You run
            the business — we'll manage the numbers.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Cta to="/contact" variant="primary" testId="finalcta-request-quote">
              Request a Quote
            </Cta>
            <Cta to="/services" variant="secondary" testId="finalcta-services">
              Explore Our Services
            </Cta>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
